import { render } from "./FAQMobileDataTableRow.vue?vue&type=template&id=33b440ec&scoped=true"
import script from "./FAQMobileDataTableRow.vue?vue&type=script&lang=js"
export * from "./FAQMobileDataTableRow.vue?vue&type=script&lang=js"

import "./FAQMobileDataTableRow.vue?vue&type=style&index=0&id=33b440ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b440ec"]])

export default __exports__